<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <a-input-search
        @pressEnter="search"
        @search="search"
        :placeholder="$t('business.label.layer')"
        v-model="query['location.y']"
      />
      <a-input-search
        @pressEnter="search"
        @search="search"
        :placeholder="$t('business.label.storageRoomName')"
        v-model="query['storageRoom.name']"
      />
      <vxe-button content="button.query" icon="vxe-icon-search" size="mini" status="primary" @click="search"/>
      <vxe-button content="button.lock" size="mini" status="primary" @click="lock"/>
      <vxe-button content="button.unlock" size="mini" status="primary" @click="unlock"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      :checkbox-config="{trigger: 'row'}"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="checkbox" width="50"/>
      <vxe-column field="storageRoom.name" title="business.label.storageRoom"/>
      <vxe-column field="location.y" title="business.label.layer"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="location.mechanicalLocking" title="business.label.locking" width="70"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>
<script>
import { findAll, post } from '@/api/Api'
import Api from '@/api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'
import { message } from 'ant-design-vue'

export default {
    name: 'LockingLayer',
    data() {
      return {
        loading: false,
        data: [],
        query: { 'storageRoom.name': '', 'location.y': '' },
        contentSize: 0,
        page: 1,
        size: 20,
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.815)// 表格竖向滚动条
      }
    },
    mounted() {
      this.getData()
    },
    methods: {
      pageChange({ currentPage, pageSize }) {
        this.page = currentPage
        this.size = pageSize
        this.getData()
      },
      getData() {
        this.loading = true
        findAll('layerFactory', this.query, this.page, this.size).then((res) => {
          if (res.success) {
            this.data = res.result
            this.contentSize = res.contentSize
          }
        }).finally(() => {
          this.loading = false
        })
      },
      unlock() {
        let selectedRows = this.$refs.table.getCheckboxRecords()
        if (selectedRows.length === 0) {
          return message.warning('请先选择需要解锁的行')
        }
        this.loading = true
        let promises = []
        new Promise(() => {
          selectedRows.forEach(item => {
            promises.push(post(Api.save, { type: 'layerPersister' }, { storageRoom: item.storageRoom, layer: item.location.y, locking: false }))
          })
        })
        Promise.all(promises).then(() => {
          this.getData()
        }).finally(() => {
          this.loading = false
        })
      },
      lock() {
        let selectedRows = this.$refs.table.getCheckboxRecords()
        if (selectedRows.length === 0) {
          return message.warning('请先选择需要锁定的行')
        }
        this.loading = true
        let promises = []
        new Promise(() => {
          selectedRows.forEach(item => {
            promises.push(post(Api.save, { type: 'layerPersister' }, { storageRoom: item.storageRoom, layer: item.location.y, locking: true }))
          })
        })
        Promise.all(promises).then(() => {
          this.getData()
        }).finally(() => {
          this.loading = false
        })
      },
      search() {
        this.page = 1
        this.getData()
      }
    }
  }
</script>
